module.exports = __webpack_public_path__ + "img/fa-regular-400.3602b7e8.svg";